import React from 'react';

import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const FilterSidebar = ({ filters, onFilterChange, onClearFilters }) => {
  const sortOptions = [
    { value: 'popular', label: 'Most Popular' },
    { value: 'recent', label: 'Recently Added' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'downloads', label: 'Most Downloaded' }
  ];

  const industryOptions = [
    { value: 'business', label: 'Business & Corporate' },
    { value: 'ecommerce', label: 'E-commerce & Retail' },
    { value: 'portfolio', label: 'Portfolio & Creative' },
    { value: 'blog', label: 'Blog & Magazine' },
    { value: 'education', label: 'Education & Learning' },
    { value: 'healthcare', label: 'Healthcare & Medical' },
    { value: 'restaurant', label: 'Restaurant & Food' },
    { value: 'realestate', label: 'Real Estate & Property' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-base md:text-lg text-foreground">Filters</h3>
        <button
          onClick={onClearFilters}
          className="text-sm text-primary hover:text-primary/80 transition-colors"
        >
          Clear All
        </button>
      </div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Sort By
          </label>
          <Select
            options={sortOptions}
            value={filters?.sortBy}
            onChange={(value) => onFilterChange('sortBy', value)}
            placeholder="Select sorting"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Template Type
          </label>
          <div className="space-y-2">
            <Checkbox
              label="Free Templates"
              checked={filters?.showFree}
              onChange={(e) => onFilterChange('showFree', e?.target?.checked)}
            />
            <Checkbox
              label="Pro Templates"
              checked={filters?.showPro}
              onChange={(e) => onFilterChange('showPro', e?.target?.checked)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Industry
          </label>
          <Select
            options={industryOptions}
            value={filters?.industry}
            onChange={(value) => onFilterChange('industry', value)}
            placeholder="All Industries"
            searchable
            clearable
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Features
          </label>
          <div className="space-y-2">
            <Checkbox
              label="Responsive Design"
              checked={filters?.responsive}
              onChange={(e) => onFilterChange('responsive', e?.target?.checked)}
            />
            <Checkbox
              label="SEO Optimized"
              checked={filters?.seoOptimized}
              onChange={(e) => onFilterChange('seoOptimized', e?.target?.checked)}
            />
            <Checkbox
              label="Dark Mode"
              checked={filters?.darkMode}
              onChange={(e) => onFilterChange('darkMode', e?.target?.checked)}
            />
            <Checkbox
              label="E-commerce Ready"
              checked={filters?.ecommerce}
              onChange={(e) => onFilterChange('ecommerce', e?.target?.checked)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Page Count
          </label>
          <div className="space-y-2">
            <Checkbox
              label="Single Page"
              checked={filters?.singlePage}
              onChange={(e) => onFilterChange('singlePage', e?.target?.checked)}
            />
            <Checkbox
              label="Multi-Page (2-5)"
              checked={filters?.multiPage}
              onChange={(e) => onFilterChange('multiPage', e?.target?.checked)}
            />
            <Checkbox
              label="Complex (6+)"
              checked={filters?.complexPage}
              onChange={(e) => onFilterChange('complexPage', e?.target?.checked)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;